<div class="d-flex flex-row">
    <div class="flex-fill">
        <p class="question"
           [innerHtml]="question.question"></p>
        <p class="guidance">{{guidanceText}}</p>
        <div *ngIf="showQuestionNumber"
             class="guidance pb-2">Q{{questionNumber}}<small> / 10</small></div>

        <div [nxtSortablejs]="question.options"
             [config]="sortableOptions">
            <div *ngFor="let option of question.options; index as i"
                 class="option d-flex">
                <div class="ps-2 flex-grow-1"><small>{{i + 1}}.&nbsp;</small>{{option.option}}</div>
                <div class="px-2 option-gripper"><i class="fa fa-grip-vertical"></i></div>
            </div>
        </div>
    </div>
</div>
